// gatsby-browser.js or gatsby-ssr.js

import handleUTMOnPageLoad from './src/utils/utm';

export const onRouteUpdate = () => {
  handleUTMOnPageLoad();
};